// import React, { useEffect } from "react";
// import SkillCard from "./SkillCard";
// import ScrollCarousel from "scroll-carousel";
// import { skillsData } from "../../assets/skillsData";
// // import AliceCarousel from "react-alice-carousel";
// import "scroll-carousel/dist/scroll.carousel.min.css";
// import './Banner.css'

// const Skills = () => {


//     useEffect(() => {
//         new ScrollCarousel(".my-carousel", { autoplay: true });
//     }, []);

//     return (
//         <div className="md:min-h-screen p-6 md:mt-28 mt-20 w-full">

//             <div data-aos="fade-up"
//                 data-aos-anchor-placement="center-bottom">
//                 {/* <h3 className="text- text-4xl text-highlight">
//                     {"<"} Skills {"/>"}
//                 </h3> */}
//                 <h3 className="text- flex justify-center text-4xl mb-6 text-highlight">
//                 <div className='flex gap-3 items-center  border-[2px] w-[159px] border-white py-1 px-5 hover:bg-white hover:text-black rounded-3xl'>Skills <span className="hover:rotate-180 "> <img className="w-6 h-6" alt="imag" loading="lazy" src="https://i.ibb.co/G3xK0m8/im.png"/></span></div>

//                     {/* {"<"} Who Am I {"/>"} */}
//                 </h3>
//                 <h1 className="md:text-5xl  text-4xl font-bold md:-2/3 w-full  text-white mt-5 text uppercase">
//                     My skills progress so far
//                 </h1>
//             </div>

//             {
//                 <div className="w-full my-carousel my-10 md:my-20" data-aos="fade-up"
//                     data-aos-anchor-placement="top-center">
//                     {skillsData.map((skillData) => (
//                         <SkillCard skillData={skillData} key={skillData.name} />
//                     ))}
//                 </div>
//             }
          
//         </div>
//     );
// };

// export default Skills;


import React, { useEffect } from "react";
import SkillCard from "./SkillCard";
import ScrollCarousel from "scroll-carousel";
import { skillsData } from "../../assets/skillsData";
import "scroll-carousel/dist/scroll.carousel.min.css";
import './Banner.css';

const Skills = () => {
  useEffect(() => {
    new ScrollCarousel(".my-carousel", { autoplay: true });
  }, []);

  return (
    <div className="h-[100vh] lg:p-12  pb-12 md:mt-28 mt-20 w-full relative">

      {/* Background Video */}
      <video
        autoPlay
        muted
        loop
        id="backgroundVideo"
        className="absolute rounded-md top-0 left-0 w-full h-full object-cover z-[-1]"
      >
        <source src="/skill-bg.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Page Content */}
      <div data-aos="fade-up" data-aos-anchor-placement="center-bottom">
        <h3 className="text- flex justify-center text-4xl mb-6  text-highlight">
          <div className="flex gap-3 items-center border-[2px] w-[159px] border-white py-1 px-5 hover:bg-white hover:text-black rounded-3xl">
            Skills <span className="hover:rotate-180 ">
              <img className="w-6 h-6" alt="imag" loading="lazy" src="https://i.ibb.co/G3xK0m8/im.png"/>
            </span>
          </div>
        </h3>
        <h1 className="md:text-5xl text-4xl font-bold md:-2/3 w-full text-white mt-5 text uppercase">
          My skills progress so far
        </h1>
      </div>

      <div className="w-full my-carousel my-10 md:my-20" data-aos="fade-up" data-aos-anchor-placement="top-center">
        {skillsData.map((skillData) => (
          <SkillCard skillData={skillData} key={skillData.name} />
        ))}
      </div>
    </div>
  );
};

export default Skills;
